<template>
	<div class="case">
		<p>请上传案例文件：</p>
		<p>有案例的上传案例，没有案例的可以上传应急预案或风险评估报告里的情景模拟内容</p>
		<el-upload class="upload-demo" action="/api/emer/plancase/upload" :headers="headers" :on-success="handleSuccess" :on-error="handleError" :on-remove="handleRemove" :data="datalist" :file-list="fileList">
			<el-button size="small" type="primary">点击上传</el-button>
		</el-upload>
	</div>
</template>
<script>
	import Burst from './../../data/emer/burst.js'
	export default {
		data() {
			return {
				fileList: [],
				datalist: {
					planId: ''
				}
			}
		},
		created() {
			if(!sessionStorage.planIdval) return
			this.datalist.planId = sessionStorage.planIdval
			this.get_plancase_list({
				planId: sessionStorage.planIdval
			})
		},
		methods: {
			// 验证
			verifyResult() {

				if(!this.fileList.length) {
					return {
						status: false,
						msg: '案例信息上传不完善，请上传'
					}
				}
				return {
					status: true,
					msg: 'ok'
				}
			},
			// 文件删除
			handleRemove(file) {
				this.remove({
					id: file.id ? file.id : file.response.id
				})

				setTimeout(() => {
					this.get_plancase_list({
						planId: sessionStorage.planIdval
					})
				}, 500)
			},
			// 文件上传失败
			handleError(err, file, fileList) {
				this.$message.error('不支持当前文件类型上传，请选择其他文件')
			},
			handleSuccess() {
				this.$message.success('文件上传成功')
				this.get_plancase_list({
					planId: sessionStorage.planIdval
				})
			},
			remove(params) {
				(async() => {
					try {
						let info = await Burst.remove_plancase(params)
						if(info.status) {
							this.$message.success('文件删除成功')
						}
					} catch(err) {
						console.log('文件删除失败')
					}
				})()
			},
			// 获取原有文件列表
			get_plancase_list(params) {
				(async() => {
					try {
						let newFileList = []
						let info = await Burst.plancase_list(params)
						if(info.status) {
							info.data.map((item) => {
								newFileList.push({
									name: item.fileName,
									url: item.filePath,
									id: item.id
								})
							})
							this.fileList = newFileList
						}
					} catch(err) {
						console.log(err)
					}
				})()
			}
		},
		computed:{
			headers(){
				return {
				'Authorization': 'Bearer '+ sessionStorage.getItem('publicToken')
				}
			}
		},
	}
</script>
<style scoped lang="stylus">
	.case {
		min-height: 450px;
		p {
			font-size: 14px;
			margin-bottom: 20px;
			margin-top: 10px;
			&:first-child {
				font-weight: bold;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// case.vue?91e22232